import { useState } from 'react';
import DebouncedInput from '~/apps/smartsend/components/DebouncedInput';
import { useSearchBox } from 'react-instantsearch-core';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from '@parcel2go/npm-p2g-app';

const SearchBox: React.FC = () => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const searchState = useSearchBox();
  const initial = typeof searchState.query === 'string' ? searchState.query : '';
  const [search, setSearch] = useState<string>(initial);
  return (
    <DebouncedInput
      id="txtSearch"
      label={t('SEARCH_BOX_SEARCH_PLACEHOLDER', { defaultValue: 'Search' })}
      value={search}
      autoComplete="none"
      debounceTime={350}
      onChange={(s) => {
        setSearch(s);
        searchState.refine(s);
      }}
      fullWidth
    />
  );
};
export default SearchBox;
